// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Páginas
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import DetalleMoto from "./pages/DetalleMoto";
import NuevaMotoAdmin from "./pages/NuevaMotoAdmin";
import AdicionarMotoAgencia from "./pages/AdicionarMotoAgencia";
import AdminAgencias from "./pages/AdminAgencias";
import AdminSucursales from "./pages/AdminSucursales";
import AdminUsers from "./pages/AdminUsers";
import AdminConfig from "./pages/AdminConfig";
import AdminSellers from "./pages/AdminSellers";
import AdminPublicaciones from "./pages/AdminPublicaciones";

// Rutas protegidas
import ProtectedRoute from "./routes/ProtectedRoute";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Público */}
        <Route path="/" element={<Login />} />

        {/* Autenticado (cualquier rol) */}
        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/detalle/:id"
          element={
            <ProtectedRoute>
              <DetalleMoto />
            </ProtectedRoute>
          }
        />

        {/* Solo ADMIN */}
        <Route
          path="/nueva-moto-admin"
          element={
            <ProtectedRoute roles={["admin"]}>
              <NuevaMotoAdmin />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/agencias"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AdminAgencias />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/sucursales"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AdminSucursales />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/users"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AdminUsers />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/config"
          element={
            <ProtectedRoute roles={["admin"]}>
              <AdminConfig />
            </ProtectedRoute>
          }
        />

        {/* Solo AGENCIA */}
        <Route
          path="/adicionar-moto"
          element={
            <ProtectedRoute roles={["agencia"]}>
              <AdicionarMotoAgencia />
            </ProtectedRoute>
          }
        />

        <Route
  path="/admin/sellers"
  element={
    <ProtectedRoute roles={["admin"]}>
      <AdminSellers />
    </ProtectedRoute>
  }
/>

<Route
  path="/admin/publicaciones"
  element={
    <ProtectedRoute roles={["admin"]}>
      <AdminPublicaciones />
    </ProtectedRoute>
  }
/>

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}